export * from './src/database';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// D:/git/platform/~/@ngrx/db/index.js
// module id = ../../../../@ngrx/db/index.js
// module chunks = 4